const LIMITE_BUEN_TIEMPO = 'limite_buen_tiempo';
const COLOR_BUEN_TIEMPO = 'color_buen_tiempo';
const LIMITE_TIEMPO_REGULAR = 'limite_tiempo_regular';
const COLOR_TIEMPO_REGULAR = 'color_tiempo_regular';
const COLOR_MAL_TIEMPO = 'color_mal_tiempo';
const TIEMPO_ANTICIPACION = 'tiempo_anticipacion';
const ESTACION = 'ESTACION';
const PREFIJO_PEDIDO = 'prefijo_pedido';
const PREFIJO_VENTA = 'prefijo_venta';
const PREFIJO_INDEFINIDO = 'prefijo_indefinido';
const TICKETS_PEDIDO_VALIDADO = 'tickets_pedido_validado';
const NUM_TICKETS_VALIDADO = 'num_tickets_validado';
const LEYENDA_NO_COBRO_ENTREGA = 'leyenda_no_cobro_entrega';
const NOTAS_TICKET_VALIDACION = 'notas_ticket_validacion';
const NOTAS_PRODUCTO_TICKET_VALIDACION = 'ticket_validacion_notas_producto';
const TELEFONO_TICKET_VALIDACION = 'telefono_ticket_validacion';
const LEYENDA_PAGARE = 'leyenda_pagare';
const PERMITIR_PRECIO_CERO = 'permitir_precio_cero';
const FORMATOS_ETIQUETAS_BALANZAS = 'formatos_etiquetas_balanzas';
const FORMATOS_ETIQUETAS_ENTRADAS = 'formatos_etiquetas_entradas';
const VALIDACION_PESO_NO_SOBREPASE_PORCENTAJE = 'validacion_peso_no_sobrepase_porcentaje';
const PORCENTAJE_MAXIMO_DIFERENCIA_PESO = 'porcentaje_maximo_diferencia_peso';
const CERRAR_VALIDACION_AUTOMATICAMENTE_PESOS_VALIDADOS = 'cerrar_validacion_automaticamente_pesos_validados';
const MONTO_MAXIMO_REPARTIDOR_PENDIENTE_ENTREGA = 'monto_maximo_repartidor_pendiente_entrega';
const RESALTAR_NOTAS_TICKET_PREPARACION = 'resaltar_notas_ticket_preparacion';
const MONTO_MAXIMO_COBRANZA_REPARTIDOR = 'monto_maximo_cobranza_repartidor';
const PEDIDO_MONITOREO_PRIORITARIO = 'pedido_monitoreo_prioritario';
const TICKET_NOMBRE_EMPRESA = 'ticket_nombre_empresa';
const TICKET_DIRECCION_EMPRESA = 'ticket_direccion_empresa';
const TICKET_TELEFONOS_EMPRESA = 'ticket_telefonos_empresa';
const TICKET_CELULAR_EMPRESA = 'ticket_celular_empresa';
const AUTORIZACION_REIMPRESION_ULTIMO_VENTA = 'autorizacion_reimpresion_ultimo_venta';
const AUTORIZACION_REIMPRESION_ESPECIFICO_VENTA = 'autorizacion_reimpresion_especifico_venta';
const AUTORIZACION_REIMPRESION_ULTIMO_VALIDACION = 'autorizacion_reimpresion_ultimo_validacion';
const AUTORIZACION_REIMPRESION_ESPECIFICO_VALIDACION = 'autorizacion_reimpresion_especifico_validacion';
const AUTORIZACION_REIMPRESION_TICKET_PREPARACION_WEB = 'autorizacion_reimpresion_ticket_preparacion_web';
const AUTORIZACION_REIMPRESION_TICKET_VALIDACION_WEB = 'autorizacion_reimpresion_ticket_validacion_web';
const AUTORIZACION_REIMPRESION_TICKET_VENTA_WEB = 'autorizacion_reimpresion_ticket_venta_web';
const IMPRESION_TICKET_ABONO = 'impresion_ticket_abono';
const IMPRESION_TICKET_MOVIMIENTO = 'impresion_ticket_movimiento';
const IMPRESION_TICKET_REPARTIDOR = 'impresion_ticket_repartidor';
const HABILITAR_DESHABILITAR_PREVALIDACION = 'habilitar_deshabilitar_prevalidacion';
const TICKET_SIZE_FONT_DIRECCION = 'ticket_size_font_direccion';
const AUTORIZACION_MOVIMIENTOS_POS = 'autorizacion_movimientos_pos';
const MOSTRAR_MONTOS_MOVIMIENTOS_CIERRE = 'mostrar_montos_movimientos_cierre';
const MOVIMIENTOS_INVENTARIO_VENTAS_PEDIDOS = 'movimientos_inventario_ventas_pedidos';
const MOVIMIENTOS_INVENTARIO_ALMACEN_ASIGNADO_PEDIDOS = 'movimientos_inventario_almacen_asignado_pedidos';
const PEDIDO_REDONDEO = 'pedido_redondeo';
const MEDIDA_A_MOSTRAR = 'medida_a_mostrar';
const FACTURACION_RFC_EMPRESA = 'facturacion_rfc_empresa';
const FACTURACION_RAZON_SOCIAL_EMPRESA = 'facturacion_razon_social_empresa';
const FACTURACION_MONTO_IVA = 'facturacion_monto_iva';
const FACTURACION_SERIE = 'facturacion_serie';
const FACTURACION_CODIGO_POSTAL = 'facturacion_codigo_postal';
const TIEMPO_NOTIFICACION_ACTIVIDAD_SOSPECHOSA_REPARTIDOR = 'tiempo_notificacion_actividad_sospechosa_repartidor';
const METROS_NOTIFICACION_ACTIVIDAD_SOSPECHOSA_REPARTIDOR = 'metros_notificacion_actividad_sospechosa_repartidor';
const RENOTIFICACION_ACTIVIDAD_SOSPECHOSA_REPARTIDOR = 'renotificacion_actividad_sospechosa_repartidor';
const PEDIDOS_MONITOR = 'pedidos_monitor';
const PANTALLA_MONITOR = 'pantalla_monitor';
const AUTORIZACION_CAMBIO_CLIENTE = 'autorizacion_cambio_cliente';
const EXPIRACION_CARRITO_WHATSAPP = 'expiracion_carrito_whatsapp';
const HORARIO_ATENCION = 'horario_atencion';
const MENSAJE_INICIAL_WP = "mensaje_inicial_wp"
const PREFIJO_AUTOCOMPLETAR_DIRECCIONES = 'prefijo_autocompletar_direcciones';
const COORDENADAS_INICIALES_MAPAS = 'coordenadas_iniciales_mapas';
const OBLIGATORIO_VALIDAR_PRODUCTOS = 'obligatorio_validar_productos';
const AUTORIZACION_APERTURA_CAJA = 'autorizacion_apertura_caja';
const AUTORIZACION_CIERRE_CAJA = 'autorizacion_cierre_caja';
const TELEFONO_NOTIFICACION_RESUMEN_OPERACION_SEMANAL = 'telefono_notificacion_resumen_operacion_semanal';

export default {
  MENSAJE_INICIAL_WP,
  PANTALLA_MONITOR,
  PEDIDOS_MONITOR,
  MEDIDA_A_MOSTRAR,
  LIMITE_BUEN_TIEMPO,
  COLOR_BUEN_TIEMPO,
  LIMITE_TIEMPO_REGULAR,
  COLOR_TIEMPO_REGULAR,
  COLOR_MAL_TIEMPO,
  TIEMPO_ANTICIPACION,
  ESTACION,
  PREFIJO_PEDIDO,
  PREFIJO_VENTA,
  PREFIJO_INDEFINIDO,
  TICKETS_PEDIDO_VALIDADO,
  NUM_TICKETS_VALIDADO,
  LEYENDA_NO_COBRO_ENTREGA,
  NOTAS_TICKET_VALIDACION,
  NOTAS_PRODUCTO_TICKET_VALIDACION,
  TELEFONO_TICKET_VALIDACION,
  LEYENDA_PAGARE,
  PERMITIR_PRECIO_CERO,
  FORMATOS_ETIQUETAS_BALANZAS,
  VALIDACION_PESO_NO_SOBREPASE_PORCENTAJE,
  PORCENTAJE_MAXIMO_DIFERENCIA_PESO,
  CERRAR_VALIDACION_AUTOMATICAMENTE_PESOS_VALIDADOS,
  MONTO_MAXIMO_REPARTIDOR_PENDIENTE_ENTREGA,
  RESALTAR_NOTAS_TICKET_PREPARACION,
  MONTO_MAXIMO_COBRANZA_REPARTIDOR,
  PEDIDO_MONITOREO_PRIORITARIO,
  TICKET_NOMBRE_EMPRESA,
  TICKET_DIRECCION_EMPRESA,
  TICKET_TELEFONOS_EMPRESA,
  TICKET_CELULAR_EMPRESA,
  AUTORIZACION_REIMPRESION_ULTIMO_VENTA,
  AUTORIZACION_REIMPRESION_ESPECIFICO_VENTA,
  AUTORIZACION_REIMPRESION_ULTIMO_VALIDACION,
  AUTORIZACION_REIMPRESION_ESPECIFICO_VALIDACION,
  AUTORIZACION_REIMPRESION_TICKET_PREPARACION_WEB,
  AUTORIZACION_REIMPRESION_TICKET_VALIDACION_WEB,
  AUTORIZACION_REIMPRESION_TICKET_VENTA_WEB,
  IMPRESION_TICKET_ABONO,
  IMPRESION_TICKET_MOVIMIENTO,
  IMPRESION_TICKET_REPARTIDOR,
  HABILITAR_DESHABILITAR_PREVALIDACION,
  TICKET_SIZE_FONT_DIRECCION,
  AUTORIZACION_MOVIMIENTOS_POS,
  MOSTRAR_MONTOS_MOVIMIENTOS_CIERRE,
  PEDIDO_REDONDEO,
  MOVIMIENTOS_INVENTARIO_VENTAS_PEDIDOS,
  MOVIMIENTOS_INVENTARIO_ALMACEN_ASIGNADO_PEDIDOS,
  FACTURACION_RFC_EMPRESA,
  FACTURACION_RAZON_SOCIAL_EMPRESA,
  FACTURACION_MONTO_IVA,
  FACTURACION_SERIE,
  FACTURACION_CODIGO_POSTAL,
  TIEMPO_NOTIFICACION_ACTIVIDAD_SOSPECHOSA_REPARTIDOR,
  METROS_NOTIFICACION_ACTIVIDAD_SOSPECHOSA_REPARTIDOR,
  RENOTIFICACION_ACTIVIDAD_SOSPECHOSA_REPARTIDOR,
  AUTORIZACION_CAMBIO_CLIENTE,
  EXPIRACION_CARRITO_WHATSAPP,
  HORARIO_ATENCION,
  PREFIJO_AUTOCOMPLETAR_DIRECCIONES,
  COORDENADAS_INICIALES_MAPAS,
  OBLIGATORIO_VALIDAR_PRODUCTOS,
  FORMATOS_ETIQUETAS_ENTRADAS,
  AUTORIZACION_APERTURA_CAJA,
  AUTORIZACION_CIERRE_CAJA,
  TELEFONO_NOTIFICACION_RESUMEN_OPERACION_SEMANAL
}
